<template>
	<AppLazyLoaderComponentFromMonolith
		:params="params"
		:container="Monolith.LAZY_CONTAINER.PROJECT_FINANCES"
	/>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Monolith } from '@/constants/monolith';
import { AppLazyLoaderComponentFromMonolith } from '@/features/App';
import { type RetainerPeriod, type Project } from '@/generated/graphql';

const props = defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();

const params = computed(() => ({
	project_id: props.projectId,
	retainerPeriodId: props.retainerPeriodId,
}));
</script>
